import axios from "axios";
import { servicePath } from 'constants/defaultValues';
import { getAccessToken } from 'helpers/Firebase';
import moment from 'moment';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
    deleteWorkListError, deleteWorkListSuccess,

    getWorkListError,
    getWorkListSuccess
} from './actions';
import {
    WORK_DELETE_ITEMS, WORK_GET_LIST
} from './actions_def';


const apiUrl = servicePath;

const getWorkListRequest = async ({ payload }) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success) => {
        const instance = axios.create({
            method: 'get',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });
        instance.get('/projects/' + payload + '/work/',
            { crossdomain: true })
            .then(response => success(response.data ?
                response.data.map(item => (
                    {
                        id: item.rfc_id,
                        title: item.rfc_title,
                        date: moment(item.date_created).format("Do MMM YYYY"),
                        change_date: moment(item.date_modified).format("Do MMM YYYY (hh:mm)"),
                        end_date: moment(item.rfc_implementation_end_date).format("Do MMM YYYY (hh:mm)"),
                        status: item.rfc_status,
                        statusColor: 'primary'
                    }
                )
                )
                :
                []));
    })
        .then((response) => response)
        .catch((error) => error);
};

function* getWorkList({ payload }) {
    // // // console.log(payload);;
    if (!payload) {
        yield put(getWorkListError({ error: 'prerequisites' }));
    }

    try {
        const response = yield call(getWorkListRequest, payload);
        yield put(getWorkListSuccess(response));
    } catch (error) {
        yield put(getWorkListError(error));
    }
}

const deleteWorkListRequest = async (items) => {
    // eslint-disable-next-line no-return-await
    return await new Promise((success, fail) => {

        // success(notificationListData.data);
        // var _user = JSON.parse(localStorage.getItem("user"));
        const instance = axios.create({
            method: 'delete',
            baseURL: apiUrl,// process.env.REACT_APP_BASE_URL,
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + getAccessToken()
            },
        });

        // console.log('Sending :', {
        //   rfc_title: item.title,
        //   rfc_type: item.type ? item.type : 1,
        //   rfc_summary: item.detail ? item.detail : ' ',
        // })
        let _status = 1;
        switch (items.status) {
            case "PENDING": _status = 1; break;
            default: _status = 1;
        };

        items.map(item => {
            console.log(item)
            instance.delete('/issues/' + item + '/',
                { crossdomain: true })
                .then(response => {
                    if (response.data) {
                        if (response.data.status === "fail") {
                            fail(response.data);
                        }
                        else if (response.data.status === "success" || response.data.status === "ok") {
                            success(response.data);
                        }
                        else {
                            console.log('Inconsistent behaviour', response.data.status)
                        }
                    }
                }).catch((error) => {
                    console.log(error)
                });
        });
    })
        .then((response) => response)
        .catch((error) => error);
};

function* deleteWorkList({ payload }) {
    // // // console.log(payload);;

    try {
        const response = yield call(deleteWorkListRequest, payload);
        yield put(deleteWorkListSuccess(response));
    } catch (error) {
        yield put(deleteWorkListError(error));
    }
}



export function* watchGetWorkList() {
    // console.log('watchGetWorkList');
    yield takeEvery(WORK_GET_LIST, getWorkList);
}

export function* watchDeleteWork() {
    yield takeEvery(WORK_DELETE_ITEMS, deleteWorkList);
}

export default function* rootSaga() {
    yield all([
        fork(watchGetWorkList),
        fork(watchDeleteWork),
    ]);
}
